// extracted by mini-css-extract-plugin
export var content = "hero-module--content--w-7+h";
export var cta = "hero-module--cta--Kx8yC";
export var label = "hero-module--label--QKelB";
export var labelWrap = "hero-module--labelWrap--0CTuZ";
export var lead = "hero-module--lead--W7e7X";
export var remaining = "hero-module--remaining--aeAOM";